module.exports = __webpack_public_path__ + "img/taylorBellsCastingHall_20201112_454.dd085b83.jpg";